import axios from "axios";

import { NETWORK_CALL_FAILED, IApiConfig } from "@hopper-b2b/types";
import { trackEvent } from "@hopper-b2b/api";
import {
  airBookingApi,
  TripPricingSummaryResponse,
  PassengersForFareRequest,
} from "@b2bportal/air-booking-api";

export const fetchTripPricing = (
  body: PassengersForFareRequest,
  apiConfig?: IApiConfig
): Promise<TripPricingSummaryResponse> =>
  new Promise(async (resolve, reject) => {
    try {
      const res = await airBookingApi(axios).apiV0TripPricePost(body);
      const responseBody: TripPricingSummaryResponse = res.data;
      resolve(responseBody);
    } catch (e) {
      trackEvent(
        {
          eventName: NETWORK_CALL_FAILED,
          properties: {
            url: window.location.pathname,
          },
        },
        apiConfig
      );
      reject(e);
    }
  });
